import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import useAuth from "src/hooks/useAuth";
import type { Id } from "src/types/id";
import type { PosGroup } from "src/types/posGroup";
import { Query } from "src/types/query";
import { UserRoleEnum } from "src/types/role";
import axios from "src/utils/axios";
import { filterPosGroupsToDisplay } from "src/utils/shouldDisplayEntity";

export const useQueryPointOfSalesGroups = (
    organizationId?: number
): UseQueryResult<PosGroup[], unknown> => {
    const { user } = useAuth();
    const displayHiddenEntities = user?.role === UserRoleEnum.SUPERADMIN;

    return useQuery({
        queryKey: [Query.PointOfSalesGroups, user.id],

        queryFn: async () =>
            filterPosGroupsToDisplay(
                (
                    await axios.get<{ posGroups: PosGroup[] }>(
                        `/posgroup?${new URLSearchParams({
                            organizationId: organizationId?.toString() ?? "",
                        }).toString()}`
                    )
                ).data.posGroups,
                displayHiddenEntities
            ),
    });
};

export const useQueryPointOfSalesGroup = (posGroupId: Id): UseQueryResult<PosGroup, unknown> => {
    const { user } = useAuth();

    return useQuery({
        queryKey: [Query.PointOfSalesGroup, user.id, posGroupId],
        queryFn: async () =>
            (await axios.get<{ posGroup: PosGroup }>(`/posgroup/${posGroupId}`)).data.posGroup,
    });
};
